module.exports = "/ui/main/images/slick-prev-sm.png?6115233af5440c081e9eec4410e66ebf";